
import { Component, Prop, Vue } from 'vue-property-decorator'
import Chart from 'chart.js'

@Component
export default class ComboChart extends Vue {
  @Prop({ default: [] }) readonly labels!: Array<string>
  @Prop({ default: [] }) readonly datasets!: Array<object>
  @Prop({
    default: () => {
      return Chart.defaults.bar
    }
  })
  readonly options: object | undefined

  mounted() {
    this.createChart({
      datasets: this.datasets,
      labels: this.labels
    })
  }

  createChart(chartData: object) {
    const canvas = document.getElementById('combochart') as HTMLCanvasElement
    const options = {
      type: 'bar',
      data: chartData,
      options: this.options
    }
    new Chart(canvas, options)
  }
}
